import { useDispatch, useSelector } from "react-redux";
import Popup from "../../../components/Popup";
import { closeShipmentDeletingPopup, deleteShipment, selectShipmentDeletingPopup, selectShipmentDeletingStatus } from "../shipmentSlice";
import { Button } from "@mui/material";
import RedSpinner from "../../../components/loaders/RedSpinner";
import { useTranslation } from "react-i18next";

const DeleteShipmentPopup = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const popupState = useSelector(selectShipmentDeletingPopup);
    const deletingStatus = useSelector(selectShipmentDeletingStatus);
    
    const closePopup = () => {
        dispatch(closeShipmentDeletingPopup());
    }

    const handleDeleteButtonClick = () => {
        if (!popupState.shipmentID) {
            return
        }
        dispatch(deleteShipment({ shipmentID: popupState.shipmentID }));
    }

    return (
        <Popup opened={popupState.opened} closeCallback={closePopup}>
            <div style={{
                height: "10vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Button
                        variant="contained"
                        sx={{
                            color: "white",
                            bgcolor: "#dc2626",
                            fontSize: "0.8rem",
                            ":hover": {
                                bgcolor: "#b91c1c",
                            },
                        }}
                        onClick={handleDeleteButtonClick}
                    >
                        {t("shipment.delete_shipment_button")} 
                        {deletingStatus === "pending" && 
                            <span className="">
                                <RedSpinner width={20} height={20}/>
                            </span>}
                    </Button>
            </div>
        </Popup>
  )
}

export default DeleteShipmentPopup